import { IGetState, TBoardId } from '../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { IChatDashboardSettings } from '../../../../../store/model/chatDashboardSettings/types';
import { getChatDashboardSettingsForRollback } from '../../../../../store/model/selectors/getChatDashboardSettingsForRollback';
import { updateAction } from '../../../../../store/model/chatDashboardSettings/actions/updateAction';
import { patchRest } from '../patchRest';
import { chatDashboardSettingsActionSet } from '../../../../../store/model/chatDashboardsSettings/actions/chatDashboardSettingsActionSet';
import { chatDashboardsSettingsActionSet } from '../../../../../store/model/actions/chatDashboardsSettingsActionSet';
import { sendAuthUserRealTimeStoreAction } from '../../../../../view/react_components/base/helpers/realTimeHelperTS';

export const chatDashboardSettingsPatchRest = (
    boardId: TBoardId,
    chatDashboardSettings: IChatDashboardSettings,
    isRealtime: boolean = true, // send event to socket
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const chatDashboardSettingsForRollback = getChatDashboardSettingsForRollback(getState(), boardId, chatDashboardSettings);
        dispatch(chatDashboardsSettingsActionSet(chatDashboardSettingsActionSet(boardId, updateAction(chatDashboardSettings))));
        return dispatch(patchRest(boardId, chatDashboardSettings))
            .then(() => {
                const update = chatDashboardsSettingsActionSet(chatDashboardSettingsActionSet(boardId, updateAction(chatDashboardSettings)));
                dispatch(update);
                if (isRealtime) {
                    dispatch(sendAuthUserRealTimeStoreAction(update))
                }
                return chatDashboardSettings;
            })
            .catch((e: any) => {
                console.error(e);
                dispatch(chatDashboardsSettingsActionSet(chatDashboardSettingsActionSet(boardId, updateAction(chatDashboardSettingsForRollback))));
            });
    };
    return action;
};
